// extracted by mini-css-extract-plugin
export default {"menuItem":"MenuItem_menuItem__DdSmR","icon":"MenuItem_icon__knNs-"};